import { useEffect, useState } from 'react'

/**
 * Hodnota oneskorená o `delayMs` — pre vyhľadávacie inputy, aby sa server
 * nedotazoval pri každom stlačení klávesy. Porovnaním s pôvodnou hodnotou sa dá
 * zistiť, či sa na oneskorenú hodnotu ešte čaká (`value !== debounced`).
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
